import React, { Component, Ref } from "react";
import { _ReactPixi, withPixiApp } from "@inlet/react-pixi";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import UIManager from "../../core/components/ui/UiBuilder";
import { alllanguage } from "../../data/lang";
import { Ilanguage } from "../../core/interface/Icommon";
import withSoundActiveScreenConfiguration from "./configuration/withSoundActiveScreenConfiguration";
import { actions as soundActiveScreenActions } from "../../gamereducer/activeSoundScreenReducer";
import { isMobile } from "react-device-detect";
import { actions as applicationActions } from "../../core/reducers/applicationStateReducer";
import { actions as soundActions } from "../../core/reducers/soundReducer";
import { actions as layoutsActions } from "../../core/reducers/layoutsStateReducer";
import { actions as basegameAction } from "../../core/reducers/baseGameReducer";
import { actions as freegameAction } from "../../core/reducers/freeGameReducer";
import { Tween } from "../../core/components/effect/tween";
import easing from "../../core/components/effect/easing";
import { actions as introductionActions } from "../../gamereducer/introductionPageReducer";
import { TIMER } from "../../core/utills";
import { actions as autoplayActions } from "../../core/reducers/autoplayReducer";
import { actions as gameLevelSoundActions } from "../../gamereducer/soundGameLevelReducer";


interface IStore {
    [x: string]: any;
}

interface IProps {
    [x: string]: any;
}

interface IStateToProps {
    [x: string]: any;
}

interface IDispatchToProps {
}

interface IState {
    [x: string]: any;
}

class SoundActiveScreen extends Component<IProps, IState> {
    protected app: PIXI.Application;
    protected soundActiveScreenContainer: _ReactPixi.IContainer | Ref<any>;
    private allLanguage: Ilanguage;
    private introductionContainerHolder: any;
    private backgroundImagePortrait: any;
    private backgroundImage: any;
    protected ui_mode: string;
    protected displayUI: any;
    protected scalingOfPortraitBg: number = 0.8;
    protected xCoordinateOfPortraitBg: number = -228;
    protected yCoordinateOfPortraitBg: number = 203;
    protected timerAmount: number = 200;
    private minFullHDWidth: number = 1024;
    private HDReadyWidth: number = 1280;
    private fullHDWidth: number = 1920;
    private minFullHDPxRatio: number = 2;
    private canvasBgImagePage: string = "";
    private tweenTimer: number = 0.001;
    private blackmaskVisibility = false;
    private screenClick: boolean = false

    constructor(props: IProps) {
        super(props);
        this.app = props.app;
        this.allLanguage = alllanguage;
        this.state = {
            uiElements: [],
            lang: "en",
            width: this.props.width,
            height: this.props.height,
            pixelRatio: window.devicePixelRatio,
            resizing: false,
            introPageSelected: 1,

        }
        if (isMobile) {
            this.ui_mode = "mobile";
        } else {
            this.ui_mode = "desktop";
        }
        this.soundActiveScreenContainer = React.createRef();
        this.displayUI = this.props.data.COMPONENTS.filter(this.checkUiMode.bind(this));

        this.blackmaskVisibility = true;

    }

    //while first rendering, this method will check the mode first
    checkUiMode(uimodeobj: any) {
        if (uimodeobj.uimode === undefined) {
            uimodeobj.uimode = "both";
        }
        if (uimodeobj.uimode === "both" || uimodeobj.uimode === this.ui_mode) {
            return uimodeobj;
        }
    }

    updateDimensions = (arg: any) => {
        if (arg === "Resized") {
            this.calculateCanvas();
        }
    };

    handleResizeChangeInIframe() {

        let
            width = 0,
            height = 0,
            scaleX = 0,
            scaleY = 0,
            scaleFactor = 0,
            viewWidth,
            viewHeight;
        let viewportWidth, viewportHeight: any, dpr;

        if (this.props.detectDevices.isAndroidMobile()) {
            if (window.devicePixelRatio > 2) {
                dpr = 1;// Math.min(window.devicePixelRatio, 2);
            } else {
                dpr = window.devicePixelRatio;
            }

        } else {
            dpr = window.devicePixelRatio;
        }

        // pixel ratios greater that 2 on some android devices mess up


        if (isMobile) {
            if (window.outerHeight > window.outerWidth) {

                viewportWidth = this.props.constant.configGame.portraitCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.portraitCanvasHeight * dpr;
            } else {

                viewportWidth = this.props.constant.configGame.landscapeCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.landscapeCanvasHeight * dpr;
            }
        } else {
            viewportWidth = this.props.constant.configGame.canvasWidth;
            viewportHeight = this.props.constant.configGame.canvasHeight;

        }

        //isMobile
        if (this.props.detectDevices.isHandheld() === true && this.props.detectDevices.isSafariBrowser() === false) {
            if (this.props.detectDevices.isIOS9Mobile() === true) {
                viewWidth = window.outerWidth;
                viewHeight = window.outerHeight;
            } else {
                viewWidth = Math.min(document.documentElement.clientWidth, window.outerWidth || 0);
                viewHeight = Math.min(document.documentElement.clientHeight, window.outerHeight || 0);
            }
        } else {
            if (isMobile) {

                viewWidth = Math.min(document.documentElement.clientWidth, window.outerWidth || 0);
                viewHeight = Math.min(document.documentElement.clientHeight, window.outerHeight || 0);
            } else {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            }

        }

        scaleFactor = viewHeight / viewportHeight;
        if (Math.round(scaleFactor * viewportWidth) > viewWidth) {
            width = viewWidth;
            scaleX = viewWidth / viewportWidth;

            height = Math.ceil(scaleX * viewportHeight);
            scaleY = scaleX;
        } else {
            height = viewHeight;
            scaleY = viewHeight / viewportHeight;

            width = Math.ceil(scaleY * viewportWidth);
            scaleX = scaleY;
        }


        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {

                Can_Width = this.props.constant.configGame.portraitCanvasWidth;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
            } else {

                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }
            if (UIManager.getRef("mainsoundActiveScreenContainer") && this.props.showSoundActiveScreen) {
                UIManager.getRef("mainsoundActiveScreenContainer").scale.x = (width * dpr) / Can_Width
                UIManager.getRef("mainsoundActiveScreenContainer").scale.y = (height * dpr) / Can_Height
            }

        }

    }

    handleResizeChange() {


        let
            width = 0,
            height = 0,
            scaleX = 0,
            scaleY = 0,
            scaleFactor = 0,
            viewWidth,
            viewHeight;
        let viewportWidth, viewportHeight: any, dpr;

        if (this.props.detectDevices.isAndroidMobile()) {
            if (window.devicePixelRatio > 2) {
                dpr = 1;// Math.min(window.devicePixelRatio, 2);
            } else {
                dpr = window.devicePixelRatio;
            }

        } else {
            dpr = window.devicePixelRatio;
        }


        if (isMobile) {
            if (window.innerHeight > window.innerWidth) {

                viewportWidth = this.props.constant.configGame.portraitCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.portraitCanvasHeight * dpr;
            } else {

                viewportWidth = this.props.constant.configGame.landscapeCanvasWidth * dpr;
                viewportHeight = this.props.constant.configGame.landscapeCanvasHeight * dpr;
            }
        } else {
            viewportWidth = this.props.constant.configGame.canvasWidth;
            viewportHeight = this.props.constant.configGame.canvasHeight;

        }

        //isMobile
        if (this.props.detectDevices.isHandheld() === true && this.props.detectDevices.isSafariBrowser() === false) {
            if (this.props.detectDevices.isIOS9Mobile() === true) {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            } else {
                viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            }
        } else {
            if (isMobile) {

                viewWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
            } else {
                viewWidth = window.innerWidth;
                viewHeight = window.innerHeight;
            }

        }
        scaleFactor = viewHeight / viewportHeight;
        if (Math.round(scaleFactor * viewportWidth) > viewWidth) {
            width = viewWidth;
            scaleX = viewWidth / viewportWidth;

            height = Math.ceil(scaleX * viewportHeight);
            scaleY = scaleX;
        } else {
            height = viewHeight;
            scaleY = viewHeight / viewportHeight;

            width = Math.ceil(scaleY * viewportWidth);
            scaleX = scaleY;
        }
        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {

                Can_Width = this.props.constant.configGame.portraitCanvasWidth;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
            } else {

                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }
            if (UIManager.getRef("mainsoundActiveScreenContainer") && this.props.showSoundActiveScreen) {
                UIManager.getRef("mainsoundActiveScreenContainer").scale.x = (width * dpr) / Can_Width
                UIManager.getRef("mainsoundActiveScreenContainer").scale.y = (height * dpr) / Can_Height
            }

        }

    }

    //to scale canvas according to mobile
    scalingOfCanvasForMobile(width: any, height: any) {
        if (isMobile) {
            let Can_Width, Can_Height;
            if (window.innerHeight > window.innerWidth) {
                this.props.setApplicationLayoutMode("Portrait");
                Can_Width = this.props.constant.configGame.portraitCanvasHeight;
                Can_Height = this.props.constant.configGame.portraitCanvasHeight;
                this.backgroundImagePortrait.scale.x += (width * window.devicePixelRatio) / (Can_Width * this.props.scaleY);
                this.backgroundImagePortrait.scale.y += (height * window.devicePixelRatio) / Can_Height;
            } else {
                this.props.setApplicationLayoutMode("Landscape");
                Can_Width = this.props.constant.configGame.landscapeCanvasWidth;
                Can_Height = this.props.constant.configGame.landscapeCanvasHeight;
            }
            this.introductionContainerHolder && (this.introductionContainerHolder.scale.x = (width * window.devicePixelRatio) / Can_Width);
            this.introductionContainerHolder && (this.introductionContainerHolder.scale.y = (height * window.devicePixelRatio) / Can_Height);
        }
    }

    iniFrame() {
        if (window.location !== window.parent.location) {

            // The page is in an iFrames
            //  document.write("The page is in an iFrame");
            return true
        } else {

            // The page is not in an iFrame
            // document.write("The page is not in an iFrame");
            return false
        }
    }

    //this method will call handle Resize change function
    calculateCanvas() {
        if (this.iniFrame()) {
            this.handleResizeChange()
        } else {
            this.handleResizeChangeInIframe()
        }
        UIManager.getRef("Text_WinMultiplier") && UIManager.setText("Text_WinMultiplier", this.props.langObj["introductionText_7"])

    }

    componentDidMount() {
        UIManager.getRef("Text_WinMultiplier") && UIManager.setText("Text_WinMultiplier", this.props.langObj["introductionText_7"])
        this.props.stoppedAutoplayOnFreeGame();
        this.layoutChange(this.props.layoutMode);
        this.chooseAssets();
        window.addEventListener('resize', this.updateDimensions);
        let resizeTimeout: any;
        window.addEventListener("resize", () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(this.updateDimensions, 100, "Resized");
        });

        if (this.props.gameBroken) {
            this.props.hideIntroductionPage();
        }
        this.updateDimensions("Resized");
        resizeTimeout = setTimeout(
            () => {
                this.updateDimensions("Resized");

            }
            , this.timerAmount)
        //   this.setDotButtonVisibility();
    }

    //this method will initialize object to variables
    initializeObjectInVariable() {
        this.backgroundImage = UIManager.getRef("backgroundImageOfIntroductionPage");
        this.backgroundImagePortrait = UIManager.getRef("backgroundImageOfIntroductionPage_portrait");

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    //when layout changes, this method will be called
    layoutChange(currentLayout: string) {


        if (isMobile && window.innerWidth < window.innerHeight) {
            UIManager.getRef("assetsContainerOfSoundWithoutBg") && (UIManager.getRef("assetsContainerOfSoundWithoutBg").visible = false);
            UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait") && (UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait").visible = true);
        }
        else {
            this.showForLandscape();
        }

        if (!this.props.isGameLoadingOver && !this.props.showSoundActiveScreen) {
            return
        }


        /*  if (this.props.freegameSpinCountRemaining != undefined) {
             return <></>
         }
         if (this.props.introductionScreenVisible === false) {
             return <></>
         } */
        this.displayUI.map((data: any) => {
            if (data.layout === true) {
                this.props.setApplicationLayoutObject(data.name);
            }
        }
        )

        let timer = TIMER.TimerManager.createTimer(20);
        timer.on("end", (e: any) => {
            if (this.screenClick) {
                let popup = UIManager.getRef("freespinBrokenPopup_container");
                popup.visible = true;
                this.addPopClickEvents();
            } else {
                if (isMobile && window.innerWidth < window.innerHeight) {
                    UIManager.getRef("assetsContainerOfSoundWithoutBg") && (UIManager.getRef("assetsContainerOfSoundWithoutBg").visible = false);
                    UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait") && (UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait").visible = true);
                }
                else {
                    this.showForLandscape();
                }
            }
        });
        timer.start();

    }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<IState>, nextContext: any): boolean {

        if (nextProps.layoutMode !== this.props.layoutMode) {
            this.layoutChange(nextProps.layoutMode)
            return false;
        }
        if (nextProps.inFreeGame !== this.props.inFreeGame) {
            return false;
        }
        if (nextProps.soundActiveScreenVisible !== this.props.soundActiveScreenVisible
            || nextProps.gameBroken !== this.props.gameBroken) {
            if (nextProps.gameBroken) {
                nextProps.hideSoundActiveScreen();
            }
            return false;
        }

        if (nextProps.isGameLoadingOver && nextProps.isGameLoadingOver !== this.props.isGameLoadingOver) {
            nextProps.soundActiveScreenShow();




            this.blackmaskVisibility = true;


            let timer = TIMER.TimerManager.createTimer(1000);
            timer.on("end", (e: any) => {
                if (UIManager.getRef("UIManager-blackGraphic")) {
                    this.tweenTo(
                        UIManager.getRef("UIManager-blackGraphic"),
                        "alpha",
                        0,
                        0.6,
                        "easeOutSine",
                        null,
                        () => {
                            this.blackmaskVisibility = false;
                        }
                    );
                }
            });
            timer.start();


            return false;
        }

        if (nextProps.resizeWidth !== this.props.resizeWidth
            || nextProps.resizeHeight !== this.props.resizeHeight

        ) {
            this.resize(nextProps);

            return false;
        }
        return true;
    }

    //this function will be called when width or Height resizes
    resize(nextProps: any) {
        if (isMobile) {
            this.introductionContainerHolder && (this.introductionContainerHolder.width = nextProps.resizeHeight);

            if (nextProps.layoutMode === "Portrait") {
                this.introductionContainerHolder && (this.introductionContainerHolder.height = nextProps.resizeWidth);
            } else {
                this.introductionContainerHolder && (this.introductionContainerHolder.height = nextProps.resizeWidth);
            }
        }
    }

    chooseAssets() {
        let screen = window.screen;

        let isFullHD = false;
        if (((screen.width >= this.minFullHDWidth || screen.height >= this.minFullHDWidth) && window.devicePixelRatio >= this.minFullHDPxRatio) ||
            (screen.width >= this.HDReadyWidth || screen.height >= this.HDReadyWidth)) {
            isFullHD = true;
        }
        if (isFullHD) {
            this.canvasBgImagePage = "HD/assets/commongame/basegame_2048.jpg";
        } else {
            this.canvasBgImagePage = "LD/assets/commongame/basegame_2048.jpg";

        }
    }

    tweenTo(object: any, property: any, target: any, time: any, easing: any, onchange: any, oncomplete: any, start?: number) {

        new Tween(
            [object],
            {

                [property]: { start: object[property], end: target }
            },
            time || this.tweenTimer,
            easing,
            false, null, null, null, null, false, onchange, oncomplete
        );

    }





    showPromotionFreeRounds(nextProps: any) {

        if (nextProps.showPromotionalScreen) {
            (window as any).PROMO_ROUNDS_HANDLER.show(true);
        }
    }

    //this method will be called when a button gets clicked
    handleEvent = (e: any) => {

        if (e.target.name === "Button_soundOn") {

            this.props.soundLoadStartFunction(true);
            this.props.stopAllBGMSound(false);
            this.props.playingSound(true);
            this.props.stopAllSFXSound(false)
            this.props.playBgSound(true);
            // this.showPopUp();

        }
        if (e.target.name === "Button_soundOff") {

            this.props.stopAllBGMSound(true);
            this.props.playingSound(false);
            this.props.stopAllSFXSound(true);
            this.props.playBgSound(false)
            //this.showPopUp();

        }
        (document.getElementsByClassName("canvasBgImage")[0] as any).src = this.canvasBgImagePage;
        //  this.props.playSound([{ name: "continueButtonSound", loop: false }]);



        this.props.showIntroductionPageFun();
        this.props.hideSoundActiveScreen();

        this.showPromotionFreeRounds(this.props);
        //this.screenClick = true;


    }

    hidePopup() {
        let freespinBrokenPopup_container = UIManager.getRef("freespinBrokenPopup_container");
        let brokenFGPopup = UIManager.getRef("freespinBrokenPopup");
        freespinBrokenPopup_container.visible = false;
        brokenFGPopup.interactive = false;
        brokenFGPopup.buttonMode = false;

        this.props.showIntroductionPageFun();
        this.props.hideSoundActiveScreen();
    }

    showPopUp() {
        // if (this.props.inFreeGame) {
        //     let freespinBrokenPopup_container = UIManager.getRef("freespinBrokenPopup_container");
        //     if (freespinBrokenPopup_container) {
        //         freespinBrokenPopup_container.visible = true;
        //         this.addPopClickEvents();
        //     }
        // } else {
        //     this.props.showIntroductionPageFun();
        //     this.props.hideSoundActiveScreen();
        // }
        this.props.showIntroductionPageFun();
        this.props.hideSoundActiveScreen();
    }

    addPopClickEvents() {
        let brokenFGPopup = UIManager.getRef("freespinBrokenPopup");
        brokenFGPopup.click = (event: any) => {
            this.hidePopup();
        }
        brokenFGPopup.touchend = (event: any) => {
            this.hidePopup();
        }
    }

    showForLandscape() {
        UIManager.getRef("assetsContainerOfSoundWithoutBg") && (UIManager.getRef("assetsContainerOfSoundWithoutBg").visible = true);
        UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait") && (UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait").visible = false);
    }

    componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
        this.initializeObjectInVariable();
        this.updateDimensions("Resized");
        if (isMobile && window.innerWidth < window.innerHeight) {
            this.backgroundImagePortrait && (this.backgroundImagePortrait.visible = true);
            this.backgroundImage && (this.backgroundImage.visible = false);
            this.layoutChange(this.props.layoutMode);



            UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait") && (UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait").scale.x = this.scalingOfPortraitBg);
            UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait") && (UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait").scale.y = this.scalingOfPortraitBg);
            UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait") && (UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait").x = this.xCoordinateOfPortraitBg);
            UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait") && (UIManager.getRef("assetsContainerOfSoundWithoutBg_portrait").y = this.yCoordinateOfPortraitBg);
        }
        if (isMobile && window.innerWidth > window.innerHeight) {
            this.backgroundImagePortrait && (this.backgroundImagePortrait.visible = false);
            this.backgroundImage && (this.backgroundImage.visible = true);

        }


        //  if (this.props.introPageSelected === 1) {
        //      this.props.changeIntroPagination(1);
        //      //this.showPageOne()
        //  }
        //
        //  if (this.props.introPageSelected === 2) {
        //      // this.props.changeIntroPagination(2);
        //      // this.showPageTwo()
        //  }

    }
    mouseOver() {

        //alert("mouseOver")
    }
    mouseOut() {
        //alert("mouseOut")

    }

    render() {

        if (!this.props.isGameLoadingOver && !this.props.showSoundActiveScreen) {
            return <></>
        }


        if (this.props.soundActiveScreenVisible === false) {
            return <></>
        }

        let blackAreaConfig = {
            name: "UIManager-blackGraphic",
            type: "Graphic",
            shape: "rectangle",
            visible: this.blackmaskVisibility,
            alpha: 1,
            color: "0x000000",
            x: 0,
            y: 0,
            width: 1920,
            height: 1080,
        };
        return (
            <UIManager id={"mainsoundActiveScreenContainer"} name={"mainsoundActiveScreenContainer"} type={"Container"} configGame={this.props.configGame}>
                <UIManager
                    visible={((this.props.showSoundActiveScreen))}
                    //  visible={((this.props.showIntroductionPage) && (this.props.freegameSpinCountRemaining==undefined || this.props.freegameSpinCountRemaining==0)? true : false)  }
                    id={"soundActiveScreenContainer"} name={"soundActiveScreenContainer"} type={"Container"}
                    configGame={this.props.configGame}
                    ref={i => this.soundActiveScreenContainer = i}>

                    {
                        this.displayUI && this.displayUI.map((i: any) =>
                            <UIManager key={`UIManager-Introduction-${Math.random()}`} langObj={this.props.langObj}
                                type={i.type}
                                id={i.id} {...i} app={this.app} ClickHandler={this.handleEvent} mouseOver={this.mouseOver} mouseOut={this.mouseOut}
                                configGame={this.props.configGame} />)
                    }

                </UIManager>
                <UIManager key={`UIManager-blackGraphic`} langObj={this.props.langObj} id={"UIManager-blackGraphic"} {...blackAreaConfig}
                    app={this.app}
                    configGame={this.props.configGame}
                />
            </UIManager>
        );
    }


}

export default withPixiApp(connect(
    (state: Pick<IStore, 'promotionalFreeRoundState' | 'soundActiveScreenState' | 'applicationState' | 'freegameState' | 'asyncInitAction'>): IStateToProps =>
    ({

        showSoundActiveScreen: state.soundActiveScreenState.showSoundActiveScreen,
        isGameLoadingOver: state.applicationState.isLoading,
        layoutMode: state.applicationState.layoutMode,
        resizeWidth: state.applicationState.resizeWidth,
        resizeHeight: state.applicationState.resizeHeight,
        soundActiveScreenVisible: state.soundActiveScreenState.soundActiveScreenVisible,
        gameBroken: state.asyncInitAction.gameBroken,
        inFreeGame: state.freegameState.inFreeGame,
        showPromotionalScreen: state.promotionalFreeRoundState.showPromotionalScreen,

    }),
    (dispatch: Dispatch): IDispatchToProps => ({
        hideSoundActiveScreen: (): any => dispatch(soundActiveScreenActions.hideSoundActiveScreen()),
        soundActiveScreenShow: (): any => dispatch(soundActiveScreenActions.soundActiveScreenShow()),
        setApplicationLayoutMode: (layout: string): any => dispatch(applicationActions.setApplicationLayoutMode(layout)),
        playSound: (soundName: any): any => dispatch(soundActions.playSound(soundName)),
        setApplicationLayoutObject: (layoutobjectlist: any): any => dispatch(layoutsActions.setApplicationLayoutObject(layoutobjectlist)),
        visibleSoundActiveScreen: (soundActiveScreenVisible: boolean): any => dispatch(soundActiveScreenActions.visibleSoundActiveScreen(soundActiveScreenVisible)),
        nextFreegame: (): any => dispatch(freegameAction.nextFreegame()),
        showIntroductionPageFun: (): any => dispatch(introductionActions.introductionPageShow()),
        stopAllBGMSound: (stopBgSound: boolean): any => dispatch(soundActions.stopAllBGMSound(stopBgSound)),
        playingSound: (soundIsPlaying: boolean): any => dispatch(soundActions.playingSound(soundIsPlaying)),
        soundLoadStartFunction: (soundLoadStart: boolean): any => dispatch(soundActions.soundLoadStartFunction(soundLoadStart)),
        stoppedAutoplayOnFreeGame: (): any => dispatch(autoplayActions.stoppedAutoplayOnFreeGame()),
        stopAllSFXSound: (stopSfxSound: any): any => dispatch(soundActions.stopAllSFXSound(stopSfxSound)),
        playBgSound: (bgSoundPlay: any): any => dispatch(gameLevelSoundActions.playBgSound(bgSoundPlay)),

    }))(withSoundActiveScreenConfiguration(SoundActiveScreen)));